import { Injectable } from '@angular/core';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import moment from 'moment';
import { ServiceaftaleStateEnum } from '../api/models/OK/Egis/Service/Models/Entities/Enums/serviceaftale-state-enum';
import { AnlaegDto } from '../api/models/OK/Egis/Service/Models/DTO/anlaeg-dto';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LogicService {
  today: Date = new Date();

  constructor(private datePipe: DatePipe) {}

  canCreateEftersyn(serviceaftale: ServiceaftaleDto) {
    if (!serviceaftale) return false;
    const daysToNaesteEftersyn = moment(serviceaftale.naesteEftersynDate).diff(moment().startOf('day'), 'days');
    return (
      (serviceaftale.serviceAbonnement.isTilkaldsabonnement || daysToNaesteEftersyn <= 60) &&
      serviceaftale.serviceaftaleState.state !== ServiceaftaleStateEnum.Terminated
    );
  }

  calculateDefaultCheckupDate(seed: Date): Date {
    let nextCheckupDate: Date = new Date(seed);
    nextCheckupDate.setDate(nextCheckupDate.getDate() + 30);
    if (nextCheckupDate.getDay() == 6 || nextCheckupDate.getDay() == 0) {
      //if weekend - get next monday
      nextCheckupDate.setDate(nextCheckupDate.getDate() + ((1 + 7 - nextCheckupDate.getDay()) % 7));
    }

    return nextCheckupDate;
  }

  buildGarantiTooltip(anlaeg: AnlaegDto): string {
    let tooltip = '';
    let komonenterWithGaranti = anlaeg?.komponenter.filter(
      (kom) => kom.installationDate && kom.garantiPeriode && this.toGarantiEndDate(kom.installationDate, kom.garantiPeriode) > this.today
    );
    komonenterWithGaranti?.forEach(
      (kom) =>
        (tooltip =
          tooltip +
          `${kom.komponentTypeTekst} - ${kom.model} har garanti frem til: ${this.datePipe.transform(
            this.toGarantiEndDate(kom.installationDate, kom.garantiPeriode)
          )}\n`)
    );

    //If anlaeg has ative garanti
    if (
      anlaeg?.garantiPeriode &&
      anlaeg?.installationDate &&
      this.toGarantiEndDate(anlaeg?.installationDate, anlaeg?.garantiPeriode) > this.today
    ) {
      tooltip =
        tooltip +
        `Anlægget har garanti frem til: ${this.datePipe.transform(
          this.toGarantiEndDate(anlaeg?.installationDate, anlaeg?.garantiPeriode)
        )}\n`;
    }

    return tooltip;
  }

  calcMaxGarantiDate(anlaeg: AnlaegDto): Date {
    let endDates = anlaeg?.komponenter
      ? anlaeg.komponenter
          .filter((kom) => kom.installationDate && kom.garantiPeriode)
          .map((kom) => this.toGarantiEndDate(kom.installationDate, kom.garantiPeriode))
      : [];
    if (anlaeg?.garantiPeriode && anlaeg?.installationDate) {
      endDates.push(this.toGarantiEndDate(anlaeg.installationDate, anlaeg.garantiPeriode));
    }

    if (endDates?.length == 0) return null;

    var maxDate = Math.max.apply(null, endDates);

    return !isNaN(maxDate) ? new Date(maxDate) : null;
  }

  private toGarantiEndDate(installDate: string, garantiPeriode: number): Date {
    return moment(installDate).add(garantiPeriode, 'month').subtract(1, 'day').toDate();
  }
}
